import { BasicDialogProperties } from "../../../basic/view/dialogs/BasicDialogProperties";

export class Poker2FadingDialogProperties extends BasicDialogProperties {
    /** Indicates the type of the dialog. E.g. "fullscreen" or "wait message" **/
    public type: string;
    public lifeTime: number = NaN;
    public copy: string;

    constructor(copy: string, lifeTime: number = 1.5, type: string = "default") {
        super();

        this.lifeTime = lifeTime;
        this.copy = copy;
        this.type = type;
    }
}
